import { Button, Row, Space, Typography } from 'antd'
import { CIMSPage } from 'shared'
import CIMSCollapse from '../../../../../../../../../components/CIMSCollapse'
import ProjectLink from '../../../../../../../../../components/ProjectLink'
import useConcreteTestPanel from './hooks/useConcreteTestPanel'
import useAsphaltLotPanel from './hooks/useAsphaltLotPanel'
import useControlPointPanel from './hooks/useControlPointPanel'
import useDensityLotPanel from './hooks/useDensityLot'
import useDensityTestPanel from './hooks/useDensityTestPanel'
import useInspectionPanel from './hooks/useInspectionPanel'
import usePunchListPanel from './hooks/usePunchListPanel'
import { useProjectSettingsContext } from '../../ProjectSettingsContext'
import { useState } from 'react'

const IFITrackerSettings = () => {
  const {
    concreteTestIFISettings: { fetching: ctFetching },
    punchListIFISettings: { fetching: plFetching },
    inspectionIFISettings: { fetching: inFetching },
    controlPointIFISettings: { fetching: cpFetching },
    densityTestIFISettings: { fetching: dtFetching },
    lotIFISettings: { fetching: lotFetching },
  } = useProjectSettingsContext()
  const setOpenPanels = (key: string | string[]) =>
    _setOpenPanels(Array.isArray(key) ? key : [key])

  const [openPanels, _setOpenPanels] = useState<string[]>([])
  return (
    <Space direction="vertical" size="small" style={{ width: '70%' }}>
      <Typography>
        CIMS Online always looks for more Identified Field Issues at every
        quarter hour.
      </Typography>
      <Typography>
        Configure which Report Types should issue Identified Field Issues.
      </Typography>
      <Typography>
        Reports issue Identified Field Issues if they are active, were created
        after their type's Effective Date, and meet their type's criteria.
      </Typography>
      <Typography>
        <ProjectLink item={CIMSPage.IFINotifications}>
          Notifications
        </ProjectLink>{' '}
        may be sent when new Identified Field Issues are issued.
      </Typography>
      <Row justify="end">
        <Button
          onClick={() => setOpenPanels([])}
          style={{ visibility: openPanels.length ? 'visible' : 'hidden' }}
        >
          Collapse All
        </Button>
      </Row>
      <CIMSCollapse
        multiple
        loading={
          ctFetching ||
          plFetching ||
          inFetching ||
          cpFetching ||
          dtFetching ||
          lotFetching
        }
        activeKey={openPanels}
        onChange={setOpenPanels}
        panels={[
          useAsphaltLotPanel(),
          useConcreteTestPanel({ openPanels, setOpenPanels }),
          useControlPointPanel({ openPanels, setOpenPanels }),
          useDensityLotPanel({ openPanels, setOpenPanels }),
          useDensityTestPanel(),
          useInspectionPanel({ openPanels, setOpenPanels }),
          usePunchListPanel(),
        ]}
      />
    </Space>
  )
}

export default IFITrackerSettings
